import React from 'react';
import { AdminLayout } from '../../components/admin/AdminLayout';
import AdminWebhooks from './subscriptions/AdminWebhooks';

const AdminWebhooksPage = () => (
  <AdminLayout>
    <AdminWebhooks />
  </AdminLayout>
);

export default AdminWebhooksPage;
